export default "__VITE_ASSET__Bo2C2qy8__"